'use strict';

/**
 * Splitter
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.Splitter = T.createModule({
	_names: {
		cookie: function cookie(postfix) {
			return 'splitClosed_' + postfix;
		}
	},

	_selectors: {
		teaser: '.m-splitter__teaser',
		// Cookie will always be set, even for links not staying on the same page.
		button: '.a-button',
		// Duration in days until the cookie expires.
		cookieDuration: 'cookie-duration',
		cookieName: 'cookie-name',
		wrapper: '.m-splitter__wrapper'
	},

	_stateClasses: {
		open: 'm-splitter--open',
		scrollLock: 'html--scroll-locked'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);
		this.$html = $(':root');
		this.$buttons = this.$ctx.find(this._selectors.button);

		this.cookiePostfix = this.$ctx.data(this._selectors.cookieName);
		var splitAlreadyClosed = window.Cookies.get(this._names.cookie(this.cookiePostfix));

		if (!splitAlreadyClosed) {
			this.$html.addClass(this._stateClasses.scrollLock);
			bodyScrollLock.disableBodyScroll(this._ctx.querySelector(this._selectors.wrapper));
			this.$ctx.addClass(this._stateClasses.open);
		}

		this.$buttons.click(this.closeOverlay.bind(this));

		resolve();
	},
	closeOverlay: function closeOverlay(event) {
		var $target = $(event.target);

		this.$html.removeClass(this._stateClasses.scrollLock);
		bodyScrollLock.enableBodyScroll(this._ctx.querySelector(this._selectors.wrapper));
		// If the posifix is not provided from drupal, we won't set a cookie.
		if (this.cookiePostfix) {
			window.Cookies.set(this._names.cookie(this.cookiePostfix), true, {
				expires: this.$ctx.data(this._selectors.cookieDuration) || 365
			});
		}
		// Keep overlay when redirect happens.
		if (!$target.attr('href')) {
			this.$ctx.removeClass(this._stateClasses.open);
		}
	}
});